var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
	return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
	version: core.version,
	mode: require('./_library') ? 'pure' : 'global',
	copyright: '(c) 2019 Denis Pushkarev (zloirock.ru)'
});